import React from "react";
import ItemContainerShared from "shared/itemLists/items/ItemContainer.shared";
import TodayBubble from "../items/itemTypes/dayHeaders/TodayBubble";
import DueItems from "../listTypes/DueItems";
import { sortableContainer, sortableElement } from "react-sortable-hoc";
import { moveItem } from "shared/itemLists/redux/itemListsSlice";
import store from "glassRedux/store";

const SortableItem = sortableElement((props) => (
  <ItemContainerShared {...props} />
));

const SortableContainer = sortableContainer(({ children }) => {
  return <ul>{children}</ul>;
});

export default class MainItemsList extends React.Component {
  constructor(props) {
    super(props);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.updateBeforeSortStart = this.updateBeforeSortStart.bind(this);
    this.state = {
      dueItemCollection: 0,
    };
  }
  shouldComponentUpdate(prevProps, prevState) {
    return (
      prevProps.mainItems !== this.props.mainItems ||
      prevProps.newTask.name !== this.props.newTask.name ||
      prevProps.dueItems !== this.props.dueItems ||
      prevState.dueItemCollection !== this.state.dueItemCollection
    );
  }

  updateBeforeSortStart(provided) {
    if (provided.index > this.props.dueItems.length) {
      this.setState({ dueItemCollection: 1 });
    }
  }

  onSortEnd({ oldIndex, newIndex }) {
    this.setState({ dueItemCollection: 0 });
    if (oldIndex === newIndex) {
      return;
    }
    store.dispatch(
      moveItem({ oldIndex, newIndex, listType: this.props.listType })
    );
  }

  onNonDueItemMouseDown() {
    this.setState({ dueItemCollection: 1 });
  }

  render() {
    let keyString = "";
    let hasBreak = false;
    let prevItem = null;
    return (
      <>
        <SortableContainer
          useDragHandle={true}
          updateBeforeSortStart={this.updateBeforeSortStart}
          onSortEnd={this.onSortEnd}
          helperClass="is-dragging"
          lockAxis="y"
          pressDelay={400}
          lockToContainerEdges={true}
        >
          {this.props.listType !== "Done" && (
            <DueItems
              dueItems={this.props.dueItems}
              listType={this.props.listType}
              currentTimeInMinutes={this.props.currentTimeInMinutes}
              dueItemCollection={this.state.dueItemCollection}
              setOpenChecklist={this.props.setOpenChecklist}
            >
              <TodayBubble
                dueItemCollection={this.state.dueItemCollection}
                dateHelper={this.props.dateHelper}
                index={this.props.dueItems.length}
              />
            </DueItems>
          )}

          {this.props.mainItems.map((item, i) => {
            const isDraggable =
              item.type !== "day_name" &&
              item.type !== "continuing_calendar_note";
            keyString = item.id ? item.id : item.day;
            prevItem = this.props.mainItems[i - 1];
            hasBreak =
              (item.type === "appointment" ||
                item.type === "task" ||
                item.type === "new_task") &&
              prevItem !== undefined &&
              (prevItem.type === "appointment" || prevItem.type === "task");
            if (item.type === "continuing_calendar_note") {
              keyString = keyString + "-" + item.current_day;
            }
            return (
              <SortableItem
                key={keyString}
                collection={0}
                disabled={!isDraggable}
                index={i + this.props.dueItems.length + 1}
                inListIndex={i}
                isToday={item.day === this.props.dateHelper.getDateString()}
                details={item}
                listType={this.props.listType}
                dateHelper={this.props.dateHelper}
                currentTimeInMinutes={this.props.currentTimeInMinutes}
                hasBreak={hasBreak}
                setCursorIndex={this.props.setCursorIndex}
                newTask={this.props.newTask}
                setNewTask={this.props.setNewTask}
                removeEmptyDay={this.props.removeEmptyDay}
                setOpenChecklist={this.props.setOpenChecklist}
              />
            );
          })}
        </SortableContainer>
      </>
    );
  }
}
